<template>
  <vs-popup
    title="Detail Aproval Penerima Dana"
    :active.sync="activatingPopUp"
    @close="activatingPopUp = false"
  >
    <main class="w-full"> 
      <div class="mt-6">
        <section class="mb-4">
          <div class="flex justify-between">
            <span class="text-grey-black text-md">
              Nama Penerima
            </span>
            <span class="text-black text-md">
              {{ namaPenerima }}
            </span>
          </div>
        </section>
        <section class="mb-4">
          <div class="flex justify-between">
            <span class="text-grey-black text-md">
              Kategori
            </span>
            <span class="text-black text-md">
              {{ kategori }}
            </span>
          </div>
        </section>
        <section class="mb-4">
          <div class="flex justify-between">
            <span class="text-grey-black text-md">
              Campaign
            </span>
            <span class="text-black text-md">
              {{ campaign }}
            </span>
          </div>
        </section>
        <section class="mb-4">
          <span class="text-grey-black mb-2 text-md">
              Deskripsi
            </span>
          <p class="text-md">
            {{ deskripsi }}
          </p>
        </section>
        <section class="mb-4">
          <span class="text-grey-black mb-2 text-md">
              Latar Belakang
            </span>
          <p class="text-md">
            {{ latarBelakang }}
          </p>
        </section>
        
      </div>
    </main>
    <footer class="mt-10">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-dropdown
                class="cursor-pointer"
              >
          <vs-button
            :color="
              statusSelected === 1
                ? 'success'
                : statusSelected === 2
                ? 'danger'
                : 'warning'
            "
            icon-after
            icon="expand_more"
            >{{
              statusListAproval[statusSelected].text
            }}</vs-button
          >
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="(item, index) in statusListAproval.filter(e => e.id !== 0)"
              :key="index"
              @click="statusSelected = item"
            >
              {{ item.text }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import statusListAproval from "@/statusListAproval.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    itemData: { type: Object, default: null }
  },
  data() {
    return {
    statusSelected : 0,
      statusListAproval,
      namaPenerima: '',
      kategori : '',
      campaign : '',
      deskripsi : '',
      latarBelakang : '',
      kategori : '',
    };
  },
  watch : {
    activate () {
      if(this.activate){
        this.namaPenerima = this.itemData.namaPenerima;
        this.deskripsi = this.itemData.deskripsi;
        this.kategori = this.itemData.kategori;
        this.campaign = this.itemData.campaign;
        this.latarBelakang = this.itemData.latarBelakang;
        this.statusSelected = this.itemData.status;
      } else {
                this.namaPenerima = '';
        this.deskripsi = '';
        this.kategori = '';
        this.campaign = '';
        this.latarBelakang = '';
        this.statusSelected  = 0;
      }
    }
  },
  computed: {
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      }
    }
  }
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
